import { h } from 'preact';
export const Minimize2 = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "4 14 10 14 10 20" }),
        h("polyline", { points: "20 10 14 10 14 4" }),
        h("line", { x1: "14", y1: "10", x2: "21", y2: "3" }),
        h("line", { x1: "3", y1: "21", x2: "10", y2: "14" })));
};
//# sourceMappingURL=minimize-2.js.map